import { useNavigate } from "@/common/hooks";

const CommonLink = ({
  id = "",
  link = "",
  text = "",
  path = "",
  className = "",
  description = "",
  wrapperClassName = "",
  disabled = false,
  children = null,
  click,
}) => {
  const navigate = useNavigate();
  return (
    <div
      className={`common-link ${wrapperClassName} ${disabled ? "disable" : ""}`}
      id={id}
    >
      <div className={`d-flex align-items-center ${className}`}>
        {link && (
          <a href={link} target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        )}
        {path || click ? (
          <>
            <span
              className="primary-color"
              onClick={path ? () => navigate(path) : click}
            >
              {text}
            </span>
            {children}
          </>
        ) : (
          <>{children}</>
        )}
      </div>
      {description && (
        <small
          className="ps-4 d-block"
          dangerouslySetInnerHTML={description}
        ></small>
      )}
    </div>
  );
};

export default CommonLink;
